import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateObjectSelected } from '@domain/_redux/pareto-ads-app-redux/action/action';
import { getObjectSelectedData } from './object-selected.state';
import { ObjectSelected } from './object-selected.types';

export interface WithObjectSelected{
    objectSelected: ObjectSelected
}

export const withObjectSelected = connect(
    state => ({
        objectSelected: getObjectSelectedData(state),
    }),
    dispatch => bindActionCreators({
        updateObjectSelected,
    }, dispatch),
);
